/**
 * Session persistence (EXT-622): keeps the pairing-code JWT + active profile
 * across reloads. restoreSession() primes the auth-token singleton
 * synchronously so screens mounted on boot already fetch authenticated.
 */
import { SaveObject, ReadObject, RemoveObject } from './storage';
import { setToken } from './auth-token';

const AUTH_KEY = 'authentication';
const PROFILE_KEY = 'currentProfile';

interface AuthState {
  jwt: string;
  [key: string]: unknown;
}

interface ProfileItem {
  id: number | string;
  [key: string]: unknown;
}

export interface RestoredSession {
  authentication: AuthState | null;
  currentProfile: ProfileItem | null;
}

export function persistSession(
  authentication: AuthState | null,
  currentProfile: ProfileItem | null,
): void {
  if (authentication?.jwt) SaveObject(AUTH_KEY, authentication);
  else RemoveObject(AUTH_KEY);

  if (currentProfile) SaveObject(PROFILE_KEY, currentProfile);
  else RemoveObject(PROFILE_KEY);
}

export function restoreSession(): RestoredSession {
  const authentication = ReadObject<AuthState>(AUTH_KEY);
  if (!authentication?.jwt) {
    return { authentication: null, currentProfile: null };
  }
  setToken(authentication.jwt);
  return { authentication, currentProfile: ReadObject<ProfileItem>(PROFILE_KEY) };
}

export function clearPersistedSession(): void {
  RemoveObject(AUTH_KEY);
  RemoveObject(PROFILE_KEY);
}
